import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledHeader = styled.div`
  width: 100%;
  height: 113px;

  display: flex;
  justify-content: right;
  align-items: center;

  border-bottom: 1px solid ${({ theme }) => theme.colorBorder};

  padding: 0 50px;
  
  .right-side-header {
    display: flex;
    align-items: center;
    justify-content: center;

    gap: 16px;
    padding: 8px;
  }

  .admin-farm-select {
    width: 450px;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: none;
  }
`;
